/* eslint-disable no-underscore-dangle */
/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ClearIcon from '@mui/icons-material/Clear';
import ScenarioContent from './scenario-content';
import { SCENARIO_CARD_CONTENT_STYLE, SCENARIO_CARD_STYLE } from '../style';
import { selectSearchData } from '../selectors';
import { searchActions } from '../slice';

/**
 * SearchResults
 *
 * Renders a responsive grid of result cards.
 * Each card displays a title, description, and related visual tags.
 *
 * Keywords inside the description are interactive:
 * - Clicking a keyword opens a popover anchored to the click target
 * - The popover dynamically renders the appropriate filter component
 *   based on the selected keyword’s filter data
 *
 * @param {Object[]} cards - List of result cards to display
 */
const SearchResults = ({ onItemClick }) => {
  const scenarios = useSelector(selectSearchData);
  //
  const dispatch = useDispatch();
  const handleItemClick = (event, card) => {
    event.stopPropagation();
    onItemClick(card);
  };
  const handleClear = () => {
    dispatch(searchActions.setSearchScenario([]));
  };
  //
  return (
    <Grid container spacing={4} px={16} pb={4}>
      <Grid item xs={6} sm={3} md={12}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ fontWeight: 'semi-bold', fontSize: 16 }}>Search Results</Typography>
          <Button sx={{ fontWeight: '500', color: '#7a7878' }} onClick={handleClear}>
            <ClearIcon sx={{ mr: 0.5, mt: 0.2 }} />
            Clear
          </Button>
        </Box>
      </Grid>
      {scenarios.map((card) => (
        <Grid item xs={6} sm={3} key={card.id}>
          <Box onClick={(e) => handleItemClick(e, card)}>
            <Card sx={SCENARIO_CARD_STYLE}>
              <CardContent sx={SCENARIO_CARD_CONTENT_STYLE}>
                <ScenarioContent scenario={card} />
              </CardContent>
            </Card>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
export default SearchResults;
